"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const container_1 = require("./container");
const globals_1 = require("./globals");
const types_1 = require("./types");
const configService = container_1.container.get(urbanjs_tools_core_1.TYPE_SERVICE_CONFIG);
configService.setGlobalConfiguration(globals_1.globals);
const api = container_1.container.get(types_1.TYPE_API);
[
    'setupInMemoryTranspile',
    'getGlobalConfiguration',
    'setGlobalConfiguration',
    'getTool',
    'initializeTask',
    'initializeTasks',
    'initializePreset',
    'initializePresets',
    'initialize'
].forEach(methodName => {
    if (typeof api[methodName] === 'function') {
        api[methodName] = api[methodName].bind(api);
    }
});
exports.default = api;
module.exports = api;
module.exports.default = api;
